<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="图片" prop="src">
          <image-upload v-model="form.url" :isShowTip="true" :limit="1" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { faceLibrarySearch } from "@/api/faceDatabase";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        platForm: null,
        url:''
      },
      // 表单校验
      rules: {
      },
    }
  },
  methods: {
    addCreateForm(platForm) {
      this.reset()
      this.open = true
      this.form.platForm = platForm
      this.title = '查询'
    },
        // 表单重置
    reset() {
      this.form = {
       platForm: null,
        url:''
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            const data = {
                platForm: this.form.platForm,
                url: this.form.url
            }
            faceLibrarySearch(data).then(response => {
                this.open = false
                if(response.data.code === 200){
                console.log(response)
              this.$modal.msgSuccess("查询成功")
              this.$emit('ok',response.data.data)
                }else{
                    this.$modal.msgError(response.data.msg)
                }
            })
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
    }
  },
  mounted() {
  }
}
</script>

<style></style>
